<template>
    <ArticlesListDefault v-if="slice.variation === 'default'" :slice="slice" />
    <ArticlesListSelection v-else :slice="slice" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {ArticlesListSlice} from '@prismicio-types';
    import ArticlesListDefault from './ArticlesListDefault.vue';
    import ArticlesListSelection from './ArticlesListSelection.vue';

    defineProps({
        ...getSliceComponentProps<ArticlesListSlice>(),
    });
</script>
